import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useCourierGps } from "@/lib/tracking";
import { GpsBanner } from "@/components/tracking/GpsBanner";
import { CourierShell, OrderHead } from "@/pages/CourierRun";

export default function CourierPickup() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.post(`/public/courier/pickup/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  const gps = useCourierGps(`/public/courier/pickup/${token}/position`, d?.order_status === "entrega");
  if (err) return <CourierShell><p className="text-center text-sm text-muted-foreground" data-testid="courier-pickup-error">{err}</p></CourierShell>;
  if (!d) return <CourierShell><p className="flex justify-center"><Loader2 className="h-6 w-6 animate-spin" /></p></CourierShell>;
  return (
    <CourierShell>
      <OrderHead d={d} />
      <div className="space-y-2 rounded-xl bg-primary/10 p-5 text-center" data-testid="courier-pickup-code">
        <p className="eyebrow">Seu código de coleta</p>
        <p className="font-mono text-6xl font-bold tracking-[0.25em] text-primary">{d.code}</p>
        <p className="text-sm text-muted-foreground">Mostre para a loja retirar o pedido.</p>
      </div>
      <p className="text-center text-xs text-muted-foreground" data-testid="courier-pickup-status">{d.order_status === "entrega" ? `Pedido marcado como saiu para entrega com ${d.courier}.` : "Aguarde a loja conferir o código."}</p>
      <GpsBanner st={gps} />
    </CourierShell>
  );
}
